import React, { useContext } from "react";
import { InitiativeContext } from "../../contexts/InitiativeContextProvider";
import { createInitiative } from "../../api/Api";
import { showToast } from "../../utils/toastUtils";
import { CreateNewEntityModalUI } from "./CreateNewProject";
import { useFormik } from "formik";
import { WorkStreamDataSchema } from "../../utils/validations";

function AddNewInitiative({ show, handleClose, project_id }) {
  const { refresh } = useContext(InitiativeContext);

  const formik = useFormik({
    initialValues: {
      name: "",
      description: "",
      start_date: "",
      end_date: "",
    },
    validationSchema: WorkStreamDataSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      setSubmitting(true);
      console.log(formik.isSubmitting);
      const payload = {
        name: values.name,
        description: values.description,
        start_date: values.start_date,
        end_date: values.end_date,
        project_id: parseInt(project_id, 10), // Convert project_id to an integer
      };
      createInitiative(payload)
        .then((response) => {
          if (response.status === 201) {
            console.log("New Initiative Added:", response.data);
            showToast("Workstream Added Successfully", "success");
            resetForm();
            handleClose();
            refresh(); 
          }
        })
        .catch((error) => {
          console.error("Failed to add initiative:", error);
          showToast("Failed to add initiative. Please try again.", "error");
        })
        .finally(() => setSubmitting(false));
    },
  });

  return (
    <CreateNewEntityModalUI
      show={show}
      handleClose={handleClose}
      formik={formik}
      title="Create New WorkStream"
      buttonText="Create"
      entity="WorkStream"
      loading={formik.isSubmitting}
    />
  );
}

export default AddNewInitiative;
